module.exports = __webpack_public_path__ + "img/READY_MV.a5091f6e.png";